export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_PAGE = 0;
